import * as z from "zod/v4";

export const voidShipments = {
  name: "voidShipments" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
